document.addEventListener('DOMContentLoaded', function () {
    const btn = document.querySelector('.site-header button[aria-label="Open menu"]');
    const nav = document.querySelector('.site-header nav');

    if (!btn || !nav) return;

    btn.addEventListener('click', function () {
        const isOpen = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
        document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on nav link click
    nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
            nav.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });
    });
});
